import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import { toast } from "react-toastify";
import { SimpleUser } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";

/**
 * The properties for {@link ExpireUserDevices}
 */
export type ExpireUserDevicesProps = {
    /** What to do on closing of the popup */
    onClose: () => void;

    /** Callback when the devices are expired */
    onExpire: () => void;

    /** The user which devices should be expired */
    user: SimpleUser;
};

/**
 * Popup to expire all devices of a selected user
 */
export default function ExpireUserDevices(props: ExpireUserDevicesProps) {
    const [t] = useTranslation("dialog-expire-user-devices");
    const [tg] = useTranslation();

    /**
     * Expire all devices of a given user
     */
    const expireUserDevices = async () => {
        await ApiInternal.users.expire(props.user.uuid);
        toast.success(t("toast.expired-user-devices"));
        props.onExpire();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.expire-user-devices", { user: props.user.display_name })}</DialogTitle>
            <DialogDescription>{t("description.expire-user-devices")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await expireUserDevices()}>
                    {t("button.expire-devices")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
